import type { App } from 'vue'
import {
  Quasar,
  QAvatar,
  QBadge,
  QBtn,
  QBtnToggle,
  QCard,
  QCarousel,
  QCarouselSlide,
  QCheckbox,
  QChip,
  QCircularProgress,
  QDate,
  QDialog,
  QExpansionItem,
  QField,
  QForm,
  QHeader,
  QIcon,
  QImg,
  QInput,
  QItem,
  QItemLabel,
  QItemSection,
  QLayout,
  QLinearProgress,
  QList,
  QMarkupTable,
  QMenu,
  QPage,
  QPageContainer,
  QRadio,
  QSelect,
  QSeparator,
  QSkeleton,
  QSlideTransition,
  QTab,
  QTabPanel,
  QTabPanels,
  QTabs,
  QTable,
  QTh,
  QTd,
  QToggle,
  QToolbar,
  QTooltip,
  QTree,
  QVirtualScroll,
  QSplitter,
  QEditor,
} from 'quasar'
import iconSet from 'quasar/icon-set/fontawesome-v6'
import variables from './assets/scss/shared/_brand.module.scss'
import './assets/main.scss'
import { configureDayjs } from './plugins/dayjs'
import { configureScrollbar } from './plugins/scrollbar'
import type { PrevioDesignSystemOptions } from './types/PrevioDesignSystemOptions'
import { applySpacingOverrides } from './overrides/spacingOverrides'
import { applyColorOverrides } from './overrides/colorOverrides'

const PrevioDesignSystem = {
  install: (app: App, options?: PrevioDesignSystemOptions) => {
    app.use(Quasar, {
      iconSet: iconSet,
      components: {
        QAvatar,
        QBadge,
        QBtn,
        QBtnToggle,
        QCard,
        QCarousel,
        QCarouselSlide,
        QCheckbox,
        QChip,
        QCircularProgress,
        QDate,
        QDialog,
        QExpansionItem,
        QField,
        QForm,
        QHeader,
        QIcon,
        QImg,
        QInput,
        QItem,
        QItemLabel,
        QItemSection,
        QLayout,
        QLinearProgress,
        QList,
        QMarkupTable,
        QMenu,
        QPage,
        QPageContainer,
        QRadio,
        QSelect,
        QSeparator,
        QSkeleton,
        QSlideTransition,
        QTab,
        QTabPanel,
        QTabPanels,
        QTabs,
        QTable,
        QTh,
        QTd,
        QToggle,
        QToolbar,
        QTooltip,
        QTree,
        QVirtualScroll,
        QSplitter,
        QEditor,
      },
      config: {
        brand: variables,
        lang: {
          noHtmlAttrs: true,
        },
      },
    })
    app.use(configureDayjs)
    app.use(configureScrollbar)
    applySpacingOverrides(options?.spacing)
    applyColorOverrides(options?.colors)
  },
}

export * from './components'
export * from './types/InternationalPhoneNumber'
export * from './types/PTheme'
export * from './types/PrevioDesignSystemOptions'
export * from './composables/helpers'
export * from './types/types'
export * from './models'
export { PrevioDesignSystem }
